import { render, staticRenderFns } from "./PackageIframe.vue?vue&type=template&id=cfefd258&scoped=true"
import script from "./PackageIframe.vue?vue&type=script&lang=js"
export * from "./PackageIframe.vue?vue&type=script&lang=js"
import style0 from "./PackageIframe.vue?vue&type=style&index=0&id=cfefd258&prod&lang=scss"
import style1 from "./PackageIframe.vue?vue&type=style&index=1&id=cfefd258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfefd258",
  null
  
)

export default component.exports